export const CLARITY_USER_ID_STORAGE_KEY = 'clarity_user_id'
